export const remodelCostOptions = [
  "Estimated Contractor Remodel Cost",
  "Itemized Remodel Cost",
];
export const developmentCostOptions = [
  "Simple Development Cost",
  "Advanced Development Cost",
];
